module.exports = __webpack_public_path__ + "static/service-excellence-89a485229c83a7ef8f8a5cc7c3a618a7.png";